import React from 'react'
import { DatePicker } from 'material-ui-pickers'

export default function DatePickerField({ input, meta, showError, ...props }) {
  const touched = meta.touched || showError
  return (
    <DatePicker
      {...props}
      keyboard
      clearable
      format="DD/MM/YYYY"
      mask={value =>
        value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : []
      }
      value={input.value || null}
      error={touched && !!meta.error}
      onError={() => input.onChange(null)}
      helperText={touched && meta.error}
      onChange={date => {
        input.onChange(date ? date.toISOString() : undefined)
      }}
      onBlur={input.onBlur}
      disableOpenOnEnter
      animateYearScrolling={false}
      cancelLabel="Cancelar"
      clearLabel="Limpar"
      okLabel="OK"
    />
  )
}
